import {push} from 'react-router-redux';
import _ from 'lodash';
import CHATED from '../../../helpers/chated-client';
import {SS_KEY} from '../../../constants';

export function loginWithBigcommerce(params) {
	return async (dispatch) => {
		// Trial One
		const response = await CHATED.bigcommerce.auth({
			callback_payload: params
		});

		console.log('bigcommerce auth response => ', response);

		if (response.meta.code === 200) {
			dispatch(handleSuccessfulAuthentication(response.data.user, response.data.auth));
			return;
		}

		dispatch(handleFailedAuthentication(_.get(params, 'shop')));
	};
}

// action helper methods
export function handleSuccessfulAuthentication(user, auth) {
	return async (dispatch) => {
		// Set token and user to session storage
		window.sessionStorage.setItem(SS_KEY.AUTH_TOKEN, auth.token);
		window.sessionStorage.setItem(SS_KEY.USER, JSON.stringify(user));
		window.sessionStorage.setItem(SS_KEY.APP_SLUG, 'bigcommerce');

		const response = await CHATED.templateConnection.getAll();
		if (response.meta.code === 200) {
			const templateConnection = _.find(response.data.template_connections, {
				template_slug: 'abandoned_cart'
			});

			if (templateConnection.enabled) {
				// redirect to email statistics page
				dispatch(push('/dashboard/emails/statistics'));
			} else {
				// redirect to settings page
				dispatch(push('/dashboard/emails/settings/general'));
			}
		}
	};
}

export function handleFailedAuthentication(shop) {
	return async (dispatch) => {
		const response = await CHATED.bigcommerce.downloadOAuthUrl({
			shop
		});

		if (response.meta.code === 200) {
			window.location.replace(response.data.auth_url);
		} else {
			dispatch(push('/'));
		}
	};
}



// WEBPACK FOOTER //
// ./src/containers/callback-bigcommerce-auth-page/actions/index.js